
import React from 'react';
import { LoadingScreen } from '@/components/ui/loading-screen';

const PortfolioSettingsLoading = () => {
  return <LoadingScreen />;
};

export default PortfolioSettingsLoading;
